module.exports = __webpack_public_path__ + "img/step_9.1bf33589.svg";